/* unplugin-vue-components disabled */import script from "./account-message.vue?vue&type=script&setup=true&lang=js"
export * from "./account-message.vue?vue&type=script&setup=true&lang=js"

import "./account-message.vue?vue&type=style&index=0&id=7a2a10ba&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2a10ba"]])

export default __exports__